"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mfaRepositoryMethods = void 0;
const repository_types_1 = require("./repository.types");
exports.mfaRepositoryMethods = (0, repository_types_1.generateRepositoryMethods)({
    setupMfa: {
        callMethod: 'POST',
        endpoint: '/auth/mfa/setup',
    },
    requestMfaTan: {
        callMethod: 'POST',
        endpoint: '/auth/mfa/request-tan',
    },
    validateMfaTan: {
        callMethod: 'POST',
        endpoint: '/auth/mfa/validate-tan',
    },
    validateMfaCredentials: {
        callMethod: 'POST',
        endpoint: '/auth/mfa/validate-credentials',
    },
    mfaLogin: {
        callMethod: 'POST',
        endpoint: '/auth/mfa/login',
    },
    validateMfaToken: {
        callMethod: 'GET',
        endpoint: '/auth/mfa/validate-token',
    },
    refreshCookie: {
        callMethod: 'POST',
        endpoint: '/auth/refresh-cookie',
    },
    revokeCookie: {
        callMethod: 'DELETE',
        endpoint: '/auth/refresh-cookie/revoke',
    },
    reflectCookie: {
        callMethod: 'GET',
        endpoint: '/auth/reflect-cookie',
    },
});
//# sourceMappingURL=mfa.methods.js.map